import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const SamsaraUsers = lazyLoader(
  () => import("Containers/SamsaraIntegration/SamsaraUsers/SamsaraUsers")
);

export const SamsaraUsersPage = () => {
  return (
    <Layout>
      <SamsaraUsers />
    </Layout>
  );
};
